import React from 'react';
import { AccordionBodyItemView } from 'component/Accordion';
import { ReactComponent as CheckBoxIcon } from 'assets/images/icons/check_box_24(1).svg';

export const UavDropMunitionsView = (props) => {
  const { formData } = props;

  return (
    <AccordionBodyItemView
      accordionSubId="3.9"
      titleUA="Скиди з БПЛА"
      titleEN="UCAV dropped munitions"
      children={
        formData.info.hazard_type.uav_drop_munitions && (
          <CheckBoxIcon />
        )
      }
    />
  );
};
